import * as Sentry from '@sentry/react'
import { createRoot } from 'react-dom/client'
import { App } from './App'
import './index.css'

const environment = import.meta.env.VITE_APP_ENVIRONEMNT || 'develop'
const isProduction = environment === 'production'

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment,
  integrations: [Sentry.browserTracingIntegration()],
  // Performance Monitoring
  tracesSampleRate: isProduction ? 0.1 : 1.0,
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: [
    // 'localhost',
    // /^https:\/\/services(\.staging)?\.fluencyflow\.ai/
  ]
})

createRoot(document.getElementById('root')!).render(<App />)
